import { render, staticRenderFns } from "./PersonalProfileCdcModule.vue?vue&type=template&id=d9c8ed5c&scoped=true&"
import script from "./PersonalProfileCdcModule.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileCdcModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c8ed5c",
  null
  
)

export default component.exports